export default __webpack_public_path__ + "static/media/wocman.98f2c630.gif";